module.exports = __webpack_public_path__ + "static/media/card.2b92469e.svg";